<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button icon-only (click)="onDismiss()" style="background: none">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      Select Dates
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid class='sm-jump-buttons' *ngIf="pickMode == 'single' && showJumpCalendar">
    <ion-row>
      <ion-col class="ion-no-padding ion-text-center">
        <ion-button expand="block" fill="clear" (click)="jumpDate(0)"><b>Today</b></ion-button>
      </ion-col>
      <ion-col class="ion-no-padding ion-text-center">
        <ion-button expand="block" fill="clear" (click)="jumpDate(14)">+2 wks</ion-button>
      </ion-col>
      <ion-col class="ion-no-padding ion-text-center">
        <ion-button expand="block" fill="clear" (click)="jumpDate(21)">+3 wks</ion-button>
      </ion-col>
      <ion-col class="ion-no-padding ion-text-center">
        <ion-button expand="block" fill="clear" (click)="jumpDate(28)">+4 wks</ion-button>
      </ion-col>
    </ion-row>
    <ion-row>          
      <ion-col class="ion-no-padding ion-text-center">
        <ion-button expand="block" fill="clear" (click)="jumpDate(35)">+5 wks</ion-button>
      </ion-col>
      <ion-col class="ion-no-padding ion-text-center">
        <ion-button expand="block" fill="clear" (click)="jumpDate(42)">+6 wks</ion-button>
      </ion-col>
      <ion-col class="ion-no-padding ion-text-center">
        <ion-button block fill="clear" (click)="jumpDate(49)">+7 wks</ion-button>
      </ion-col>
      <ion-col class="ion-no-padding ion-text-center">
        <ion-button block fill="clear" (click)="jumpDate(56)">+8 wks</ion-button>
      </ion-col>
    </ion-row>
    <ion-row>          
      <ion-col size="3" class="ion-no-padding ion-text-center">
        <ion-button block fill="clear" (click)="jumpDate(63)">+9 wks</ion-button>
      </ion-col>
      <ion-col size="3" class="ion-no-padding ion-text-center">
        <ion-button block fill="clear" (click)="jumpDate(70)">+10 wks</ion-button>
      </ion-col>
      <ion-col size="3" class="ion-no-padding ion-text-center">
        <ion-button block fill="clear" (click)="jumpDate(77)">+11 wks</ion-button>
      </ion-col>
      <ion-col size="3" class="ion-no-padding ion-text-center">
        <ion-button block fill="clear" (click)="jumpDate(84)">+12 wks</ion-button>
      </ion-col>
    </ion-row>        
  </ion-grid>

  <ion-grid class='sm-range-buttons' *ngIf="pickMode == 'range' && showJumpCalendar">
    <ion-row>
      <ion-col class="ion-no-padding ion-text-center">
        <ion-button expand="block" fill="clear" (click)="pickRange('today')" class="ion-no-padding">Today</ion-button>
      </ion-col>     
      <ion-col class="ion-no-padding ion-text-center">
        <ion-button expand="block" fill="clear" (click)="pickRange('this-week')" class="ion-no-padding">This Week</ion-button>          
      </ion-col>  
      <ion-col class="ion-no-padding ion-text-center">
        <ion-button expand="block" fill="clear" (click)="pickRange('this-month')" class="ion-no-padding">This Month</ion-button>
      </ion-col>
      <ion-col class="ion-no-padding ion-text-center">
        <ion-button expand="block" fill="clear" (click)="pickRange('this-year')" class="ion-no-padding">This Year</ion-button>
      </ion-col>          
    </ion-row>
    <ion-row>
      <ion-col class="ion-no-padding ion-text-center">
        <ion-button expand="block" fill="clear" (click)="pickRange('yesterday')" class="ion-no-padding">Yesterday</ion-button>
      </ion-col>   
      <ion-col class="ion-no-padding ion-text-center">
        <ion-button expand="block" fill="clear" (click)="pickRange('last-week')" class="ion-no-padding">Last Week</ion-button>
      </ion-col>
      <ion-col class="ion-no-padding ion-text-center">
        <ion-button expand="block" fill="clear" (click)="pickRange('last-month')" class="ion-no-padding">Last Month</ion-button>
      </ion-col>
      <ion-col class="ion-no-padding ion-text-center">
        <ion-button expand="block" fill="clear" (click)="pickRange('last-year')" class="ion-no-padding">Last Year</ion-button>
      </ion-col>                    
    </ion-row>        
  </ion-grid>  
  <ion-grid class="ion-no-padding">
    <ion-row>
      <ion-col class="ion-no-padding ion-text-center" >
          <p-calendar 
          [style]="{'width': '100%'}"
          class="sm-daterangepicker"
          [(ngModel)]="defaultSelection" 
          [inline]="true" 
          [numberOfMonths]="1" 
          [selectionMode]="pickMode"
          (onSelect)="onSelect($event)"
          >
        </p-calendar>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer class="ion-no-border" *ngIf="pickMode == 'range'">
  <ion-button
    expand="block"
    
    class="ion-no-margin"
    color="primary" 
    [disabled]="!isEnabled()"
    (click)="selectDate()"
  >
    Apply
  </ion-button>
</ion-footer>